/*
<template>
	<div style="display: flex">
		<!-- **년 월별 실적 -->
		<sf-card width="1800px" height="330px" :title="getMessage_('QWCC001701')" style="margin-top: -4px; margin-left: 19px">
			<line-chart :height="280" ref="grpLine" :chartData="datacollection1" :options="options1" />
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcQrty/store/helpers';
export default {
	components: {
		LineChart: Chart.LineChart
	},
	data() {
		return {
			options1: {
				//Linechart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: true,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: false,
								min: 0,
								stepSize: 6
							}
						}
					],
					xAxes: [
						{
							offset: true, //x축 앞에 공간 두는 설정
							gridLines: {
								display: false //x축 관련 실선 안보이게 처리
							}
						}
					]
				}
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.LineChartLabel_, //x축 데이터( 년월)
				datasets: this.lineDataSet_
			};
		}
		// datacollection2() {
		// 	return {
		// 		labels: this.stackedLabel_,
		// 		datasets: this.stackedDataSet_
		// 	};
		// }
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
